<template lang='pug'>
  button.save.button.component( :type='type' :title='title' )
    icon
</template>

<script>
	import Icon from 'vue-material-design-icons/ContentSave.vue'

  export default {
		name: 'save.button.component',
		
		components: {
			Icon
		},

    props: {
      type: { type: String, default: 'button' },
      title: { type: String, default: 'Edit Button' }
    }
  }
</script>

<style scoped lang='stylus'>
	button
		color rgb( 64 64 64 )
		cursor pointer
		padding 8px
</style>
